module.exports = __webpack_public_path__ + "assets/app_store.png?9fa389879191d14fc2bdf4dbc6ca6a30";